// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmployeeEmployerInfoDto
 */
export interface IEmployeeEmployerInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IEmployeeEmployerInfoDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeEmployerInfoDto
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeEmployerInfoDto
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeEmployerInfoDto
     */
    employer_employee_id: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeEmployerInfoDto
     */
    partner_employee_id: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeEmployerInfoDto
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeEmployerInfoDto
     * @deprecated
     */
    employer: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeEmployerInfoDto
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeEmployerInfoDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeEmployerInfoDto
     */
    is_reimbursement_allowed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeEmployerInfoDto
     */
    is_fraud_review_required?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeEmployerInfoDto
     */
    fraud_review_required_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeEmployerInfoDto
     */
    last_4_ssn_digits: string;
}

/**
 * Check if a given object implements the IEmployeeEmployerInfoDto interface.
 */
export function instanceOfIEmployeeEmployerInfoDto(value: object): value is IEmployeeEmployerInfoDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('employer_employee_id' in value) || value['employer_employee_id'] === undefined) return false;
    if (!('partner_employee_id' in value) || value['partner_employee_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('employer' in value) || value['employer'] === undefined) return false;
    if (!('last_4_ssn_digits' in value) || value['last_4_ssn_digits'] === undefined) return false;
    return true;
}

export function IEmployeeEmployerInfoDtoFromJSON(json: any): IEmployeeEmployerInfoDto {
    return IEmployeeEmployerInfoDtoFromJSONTyped(json, false);
}

export function IEmployeeEmployerInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeEmployerInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'employer_employee_id': json['employer_employee_id'],
        'partner_employee_id': json['partner_employee_id'],
        'status': json['status'],
        'employer': json['employer'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'is_reimbursement_allowed': json['is_reimbursement_allowed'] == null ? undefined : json['is_reimbursement_allowed'],
        'is_fraud_review_required': json['is_fraud_review_required'] == null ? undefined : json['is_fraud_review_required'],
        'fraud_review_required_at': json['fraud_review_required_at'] == null ? undefined : (new Date(json['fraud_review_required_at'])),
        'last_4_ssn_digits': json['last_4_SSN_digits'],
    };
}

export function IEmployeeEmployerInfoDtoToJSON(json: any): IEmployeeEmployerInfoDto {
    return IEmployeeEmployerInfoDtoToJSONTyped(json, false);
}

export function IEmployeeEmployerInfoDtoToJSONTyped(value?: IEmployeeEmployerInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'employer_employee_id': value['employer_employee_id'],
        'partner_employee_id': value['partner_employee_id'],
        'status': value['status'],
        'employer': value['employer'],
        'employer_name': value['employer_name'],
        'subsidiary_name': value['subsidiary_name'],
        'is_reimbursement_allowed': value['is_reimbursement_allowed'],
        'is_fraud_review_required': value['is_fraud_review_required'],
        'fraud_review_required_at': value['fraud_review_required_at'] == null ? undefined : ((value['fraud_review_required_at']).toISOString()),
        'last_4_SSN_digits': value['last_4_ssn_digits'],
    };
}

